import React, { useState, useEffect } from 'react';

const ConsultancyPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showHindi, setShowHindi] = useState(false);

useEffect(() => {
  const hasShown = sessionStorage.getItem('azybyte_popup_shown');

  if (!hasShown) {
    const timer = setTimeout(() => {
      setIsVisible(true);
      sessionStorage.setItem('azybyte_popup_shown', 'true');
    }, 5000);

    return () => clearTimeout(timer);
  }
}, []);

  useEffect(() => {
  if (isVisible) {
    const languageTimer = setTimeout(() => {
      setShowHindi(true);
    }, 6000); // Switch to Hindi after 4 sec

    return () => clearTimeout(languageTimer);
  }
}, [isVisible]);

useEffect(() => {
  if (isVisible) {
    const autoCloseTimer = setTimeout(() => {
      setIsVisible(false);
    }, 15000); // Auto close after 10 sec

    return () => clearTimeout(autoCloseTimer);
  }
}, [isVisible]);

  if (!isVisible) return null;

  return (
      <div
        data-aos="fade-up"
        style={{
          position: 'fixed',
          bottom: window.innerWidth < 768 ? '15px' : '30px',
          right: window.innerWidth >= 768 ? '30px' : 'auto',
          left: window.innerWidth < 768 ? '50%' : 'auto',
          transform: window.innerWidth < 768 ? 'translateX(-50%)' : 'none',

          width: window.innerWidth < 768 ? '95%' : '320px',
          maxWidth: '420px',

          backgroundColor: '#0f172a',
          color: 'white',
          padding: '16px',
          borderRadius: '14px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
          zIndex: 9999,
          borderLeft: '4px solid #3b82f6'
        }}
      >
      <button
        onClick={() => setIsVisible(false)}
        aria-label="Close popup"
        style={{ position: 'absolute', top: '10px', right: '10px', background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer' }}
      >✕</button>

      <h3
  style={{
    margin: '0 0 6px 0',
    fontSize: '16px',
    color: '#3b82f6'
  }}
>
  Free IT Consultancy
</h3>

<p
  style={{
    fontSize: '13px',
    color: '#cbd5e1',
    lineHeight: '1.5',
    margin: '0 0 12px 0'
  }}
>

  {!showHindi ? (
    <>
      Want to shift your business online, build an AI chatbot,
      automate your work, or create any custom web/app project?
      Get free expert consultation from AzyByte Technologies.
    </>
  ) : (
    <>
      क्या आप अपने बिज़नेस को ऑनलाइन ले जाना चाहते हैं, AI चैटबॉट बनवाना चाहते हैं,
      या कोई कस्टम वेबसाइट / ऐप प्रोजेक्ट बनवाना चाहते हैं?
      AzyByte Technologies से मुफ्त कंसल्टेशन प्राप्त करें।
    </>
  )}
</p>

      <a
  href="https://wa.me/919998203277?text=Hello,I'm%20inquiring%20for%20service%20from%20AzyByte Technologies"
  style={{
    display: 'block',
    textAlign: 'center',
    padding: '9px',
    backgroundColor: '#3b82f6',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '14px'
  }}
>
  Talk to an Expert
</a>
    </div>
  );
};

export default ConsultancyPopup;